'use client'

import { ToolLandingTemplate } from '../_components/tool-landing-template'
import { restaurant_website_builderConfig } from './config'
import type { User } from '@/lib/types'

interface RestaurantWebsiteBuilderClientProps {
  user: User | null
}

export default function RestaurantWebsiteBuilderClient({
  user,
}: RestaurantWebsiteBuilderClientProps) {
  return (
    <ToolLandingTemplate
      user={user}
      config={restaurant_website_builderConfig}
    />
  )
}
